import OTP from '../OTP/OTP.js';

class ModuleForms {
    constructor() {
        let _this = this;

        let inpRadiosCircle = document.querySelectorAll('.js-circle-select');
        inpRadiosCircle.forEach((wrapperCircle) => {
            let inpRadios = wrapperCircle.querySelectorAll('input[type="radio"]');
            let value = wrapperCircle.querySelector('.text-circle-value');
            if (!value){
                return;
            }
            inpRadios.forEach((inpRadio) => {
                inpRadio.addEventListener('click', () => {
                    value.innerHTML = inpRadio.dataset.circle;
                })
            })
        })

        let inpNumbers = document.querySelectorAll('.field-only-number');
        inpNumbers.forEach((inpNumber) => {
            _this.setInputFilter(inpNumber, function(value) {
                return /^\d*\.?\d*$/.test(value); // Allow digits and '.' only, using a RegExp.
            }, "");
        })

        let inpExpDates = document.querySelectorAll('.field-exp-date');
        inpExpDates.forEach((inpExpDate) => {
            inpExpDate.addEventListener('input', function(e) {
                let value = this.value.replace(/\D/g, ''); // bỏ ký tự không phải số
                if (value.length >= 3) {
                    value = value.substring(0, 2) + ' / ' + value.substring(2, 4);
                }
                this.value = value.substring(0, 7); // Giới hạn 7 ký tự: "MM / YY"
            });
        });
        
        let inpBirthDays = document.querySelectorAll('.field-birdthday');
        inpBirthDays.forEach((inpBirthDay) => {
            inpBirthDay.addEventListener('input', function () {
                let value = this.value.replace(/\D/g, ''); // chỉ giữ số

                let output = '';

                if (value.length > 0) {
                    output = value.substring(0, 2); // DD
                }
                if (value.length > 2) {
                    output += '/' + value.substring(2, 4); // MM
                }
                if (value.length > 4) {
                    output += '/' + value.substring(4, 8); // YYYY
                }

                this.value = output;
            });
        });

        if (document.querySelector('.otp-input-container') && document.querySelector('.otp-result-input')){
            const initOTPInput = new OTP(
                '.otp-input-container',
                '.otp-result-input',
            );
        }

        const groupPass = document.querySelectorAll('.group-password');
        groupPass.forEach((item) => {
            const inputItem = item.querySelector('.input-password');
            const toggleItem = item.querySelector('.toggle-password');

            this.togglePasswordVisibility(toggleItem, inputItem)
        })


        this.rangeSliderHeight();
        this.rangeSliderWeight();
        this.productQuanlityHandle();
    }

    productQuanlityHandle = function(){
        document.querySelectorAll('.product-quantity').forEach(container => {
            const input = container.querySelector('input[type="number"]');
            const display = container.querySelector('.product-item-number');
            const decrease = container.querySelector('.product-item-decrease');
            const increase = container.querySelector('.product-item-increase');

            const min = parseInt(input.min) || "";
            const max = parseInt(input.max) || Infinity;

            const updateDisplay = (value) => {
                if (isNaN(value) || value < min) value = min;
                if (value > max) value = max;

                input.value = value;
                display.textContent = value;
            };

            decrease.addEventListener('click', () => {
                let value = parseInt(input.value);
                if (isNaN(value)) value = min;
                updateDisplay(value - 1);
            });

            increase.addEventListener('click', () => {
                let value = parseInt(input.value);
                if (isNaN(value)) value = min;
                updateDisplay(value + 1);
            });

            input.addEventListener('input', () => {
                updateDisplay(parseInt(input.value));
            });

            input.addEventListener('blur', () => {
                updateDisplay(parseInt(input.value));
            });
        });
    }

    rangeSliderHeight = function(){
        const sliderHeight = document.querySelectorAll('.range-height-slider');
        sliderHeight.forEach(function(itemHeihgt){
            const rangeSlider = itemHeihgt.querySelector('.range-slider');
            const tooltip = itemHeihgt.querySelector('.tooltip');
    
            const maxVal = parseInt(rangeSlider.max);
            const minVal = parseInt(rangeSlider.min);
    
            function sliderPrice() {
                let progress = ((rangeSlider.value - minVal) / (maxVal - minVal)) * 100;
                tooltip.style.left = progress + "%";
                rangeSlider.style.background = `linear-gradient(to right, #A2550B ${progress}%, #D9D9D9 ${progress}%)`;
    
                let val = parseInt(rangeSlider.value);
                let m = Math.floor(val / 100);
                let cm = val % 100;
    
                if (val == 0){
                    tooltip.innerHTML = val;
                }
                else if (val < 100) {
                    tooltip.innerHTML = cm + "cm";
                } else if (cm === 0) {
                    tooltip.innerHTML = m + "m";
                } else {
                    tooltip.innerHTML = m + "m" + cm.toString().padStart(2, "0");
                }
    
                if (val == minVal){
                    tooltip.style.transform = "none";
                    tooltip.style.marginLeft = "0";
                }
                else if (val == maxVal){
                    tooltip.style.transform = "translate(-100%, 0)";
                    tooltip.style.marginLeft = "0";
                }else{
                    tooltip.style.transform = "";
                    tooltip.style.marginLeft = "";
                }
            }
            rangeSlider.addEventListener('input', sliderPrice);
            sliderPrice();
        })
    }

    rangeSliderWeight = function(){
        const sliderHeight = document.querySelectorAll('.range-weight-slider');
        sliderHeight.forEach(function(itemHeihgt){
            const rangeSlider = itemHeihgt.querySelector('.range-slider');
            const tooltip = itemHeihgt.querySelector('.tooltip');
    
            const maxVal = parseInt(rangeSlider.max);
            const minVal = parseInt(rangeSlider.min);
    
            function sliderPrice() {
                let progress = ((rangeSlider.value - minVal) / (maxVal - minVal)) * 100;
                tooltip.style.left = progress + "%";
                rangeSlider.style.background = `linear-gradient(to right, #A2550B ${progress}%, #D9D9D9 ${progress}%)`;
    
                let val = parseInt(rangeSlider.value);
                tooltip.innerHTML = val + "kg";
    
                if (val == minVal){
                    tooltip.style.transform = "none";
                    tooltip.style.marginLeft = "0";
                }
                else if (val == maxVal){
                    tooltip.style.transform = "translate(-100%, 0)";
                    tooltip.style.marginLeft = "0";
                }else{
                    tooltip.style.transform = "";
                    tooltip.style.marginLeft = "";
                }
            }
            rangeSlider.addEventListener('input', sliderPrice);
            sliderPrice();
        })
    }

    togglePasswordVisibility = function(toggleButton, passwordInput){
        if (!toggleButton || !passwordInput) return;
        const svgEyeOn = `<svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.9835 7.34385C16.3696 10.242 13.309 12.0424 9.99766 12.0424C6.68414 12.0424 3.62355 10.242 2.00965 7.34385C1.88535 7.11881 1.88535 6.88092 2.00965 6.65607C3.62355 3.75795 6.68414 1.95779 9.99766 1.95779C13.309 1.95779 16.3696 3.75795 17.9835 6.65607C18.11 6.88092 18.11 7.11881 17.9835 7.34385ZM19.0145 6.08146C17.1927 2.80932 13.7377 0.776855 9.99766 0.776855C6.25547 0.776855 2.80051 2.80932 0.978711 6.08146C0.65293 6.66529 0.65293 7.33463 0.978711 7.91803C2.80051 11.1902 6.25547 13.2231 9.99766 13.2231C13.7377 13.2231 17.1927 11.1902 19.0145 7.91803C19.3402 7.33467 19.3402 6.66529 19.0145 6.08146ZM9.99766 9.4224C11.3329 9.4224 12.4196 8.33576 12.4196 6.99986C12.4196 5.66396 11.3329 4.57732 9.99766 4.57732C8.66023 4.57732 7.57359 5.66396 7.57359 6.99986C7.57359 8.33576 8.66027 9.4224 9.99766 9.4224ZM9.99766 3.39639C8.00867 3.39639 6.39266 5.01307 6.39266 6.9999C6.39266 8.98717 8.00871 10.6032 9.99766 10.6032C11.9845 10.6032 13.6005 8.98713 13.6005 6.9999C13.6005 5.01307 11.9845 3.39639 9.99766 3.39639Z" fill="black"/>
                        </svg>`;
        const svgEyeOff = `<svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.14551 0.854004L18.8548 13.146L18.1455 14.146L14.8413 11.7911C13.3706 12.4696 11.7338 12.8331 9.99978 12.8331C6.25531 12.8331 2.80035 10.8006 0.978553 7.52847C0.652772 6.94464 0.652772 6.2753 0.978553 5.69147C1.83674 4.16924 3.04214 2.90301 4.48474 1.97967L0.854802 0.146004L1.14551 0.854004ZM5.6337 2.73592C4.3677 3.53461 3.25535 4.6726 2.46335 6.08147C2.33785 6.30631 2.33785 6.54421 2.46335 6.76904C4.07725 9.66717 7.13783 11.4673 10.4514 11.4673C11.7435 11.4673 12.9808 11.1618 14.0802 10.6085L12.3175 9.3481C11.6935 9.7458 10.9105 9.97174 9.99978 9.97174C8.29064 9.97174 6.92798 8.60907 6.92798 6.89994C6.92798 5.98921 7.15392 5.20623 7.55162 4.58223L5.6337 2.73592ZM8.77112 5.67318C8.34828 6.15818 8.14412 6.65051 8.14412 6.99994C8.14412 7.88284 8.96822 8.70694 9.85112 8.70694C10.2006 8.70694 10.6929 8.50278 11.1779 8.07994L8.77112 5.67318ZM15.0042 9.5914L16.275 10.5065C17.2546 9.65564 18.0768 8.58541 18.5379 7.52847C18.8636 6.94464 18.8636 6.2753 18.5379 5.69147C16.7161 2.41933 13.2611 0.386871 9.51896 0.386871C8.04596 0.386871 6.66002 0.737737 5.42562 1.36487L6.23502 2.12927C7.31622 1.61841 8.47382 1.33313 9.71042 1.33313C13.0239 1.33313 16.0845 3.13329 17.6984 6.03142C17.8239 6.25626 17.8239 6.49416 17.6984 6.71899C17.0604 7.8773 16.0947 8.8739 15.0042 9.5914Z" fill="black"/>
                        </svg>`;
        let isPassword = passwordInput.type === 'password';
        toggleButton.innerHTML = isPassword ? svgEyeOn : svgEyeOff;
        
        toggleButton.addEventListener('click', function () {
            isPassword = passwordInput.type === 'password';
            passwordInput.type = isPassword ? 'text' : 'password';
            this.innerHTML = isPassword ? svgEyeOff : svgEyeOn;
        });
    }

    setInputFilter = function(textbox, inputFilter, errMsg) {
        [ "input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop", "focusout" ].forEach(function(event) {
            textbox.addEventListener(event, function(e) {
            if (inputFilter(this.value)) {
                // Accepted value.
                if ([ "keydown", "mousedown", "focusout" ].indexOf(e.type) >= 0){
                this.classList.remove("input-error");
                this.setCustomValidity("");
                }

                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            }
            else if (this.hasOwnProperty("oldValue")) {
                this.classList.add("input-error");
                this.setCustomValidity(errMsg);
                this.reportValidity();
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
            else {
                // Rejected value: nothing to restore.
                this.value = "";
            }
            });
        });
    }
}

export default ModuleForms; 